import React from 'react';
import { connect } from 'react-redux';

import { formatDate } from '../calendar.model.js';
import { dateFormatSettings } from '../../settings/settings.consts.js';

function Inspections({ inspections, user, tableStyle = 'resourceView' }) {
  if (!inspections.length) {
    return null;
  }

  const titleStyle = tableStyle === 'checkout' ? 'text-muted' : 'stronger';
  const tableWrraperStyle =
    tableStyle === 'checkout' ? 'table-inspection-wrap' : 'table-meters-wrap';
  const nameStyle = tableStyle === 'checkout' ? 'stronger' : 'meter-name';
  const subnameStyle = tableStyle === 'checkout' ? 'table-inspection-subname' : 'meter-name';

  return (
    <div className="meters-inspections-wrap">
      <div className="meters">
        <h5 className="discrepancies-modal-heading">Inspections</h5>
        <div className={tableWrraperStyle}>
          <table className="table table-sm table-meters">
            <thead>
              <tr>
                <td className={titleStyle}>Name</td>
                <td className={`text-right ${titleStyle}`}>Due Date/Meter</td>
                <td className={`text-right ${titleStyle}`}>Time Left</td>
              </tr>
            </thead>
            <tbody>
              {inspections.length &&
                inspections.map(
                  ({ counterExpirationValue, dueDate, inspectionName, dueIn, id }, index) => {
                    const inspectionTimestamp = new Date(dueDate).getTime() / 1000;
                    const dueDateValue = formatDate(
                      inspectionTimestamp,
                      0,
                      dateFormatSettings[user.settings.date]
                    );
                    const dueDateAndCounterValue = counterExpirationValue || dueDateValue;

                    return (
                      <tr key={`inspection-${id}-${index}`} className="middle">
                        <td>
                          <div className={nameStyle} children={inspectionName} />
                        </td>
                        <td>
                          <div
                            className={`${subnameStyle} text-right`}
                            children={dueDateAndCounterValue}
                          />
                        </td>
                        <td>
                          <div className={`${subnameStyle} text-right`} children={dueIn} />
                        </td>
                      </tr>
                    );
                  }
                )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
// TODO need to update react and react-redux for use useSelector
const mapStateToProps = state => ({
  user: state.user,
  inspections: state.aircraft && state.aircraft.inspections ? state.aircraft.inspections : []
});

export default connect(
  mapStateToProps,
  {}
)(Inspections);
